import React, { ComponentProps } from 'react';
import { asWidgetProps } from 'Src/types/widget-helpers';
import { useSelector } from 'react-redux';
import { t } from 'Src/i18n';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { InputSwitch } from 'Components/frameworks/form-inputs/input-switch/InputSwitch';
type Props = {
  className?: string;
  isDisabled?: boolean;
  onChange: FilterItemOnChangeFunc;
  selectedOptions: Array<FilterOptionProps>;
};
export const FilterMobility = ({
  className,
  isDisabled = false,
  onChange,
  selectedOptions = [],
}: Props) => {
  const result = useSelector((state) => state.booking.additionalAccommodations);
  const isActive = Boolean(result?.isPmrChecked);
  const { trackClickEvent } = useTrackEvent();
  const handleCheck = (): void => {
    onChange('reducedMobilityVisibility', selectedOptions, null);
    trackClickEvent(TRACK_EVENT_NAMES.CLICK_ACCOMMODATION_LAYER, {
      detail_click: 'filter_mobility',
    });
  };
  return (
    <InputSwitch
      {...asWidgetProps<ComponentProps<typeof InputSwitch>>({
        checked: isActive,
        className: className,
        isDisabled: isDisabled,
        label: t('filters.reducedMobilityCheckbox'),
        name: 'filters.reducedMobility',
        onChange: handleCheck,
        size: 'small',
      })}
    />
  );
};
